import { useStore } from '@nanostores/react';
import { useEffect } from 'react';
import { PricingCardActionButton } from '~/components/ui/pricing/Card/Action';
import { PricingSelector } from '~/components/ui/pricing/Card/PricingSelector';
import {
  PricingCardMessages,
  PricingPerks,
  PricingPrice,
  PricingSettingSectionWrapper,
} from '~/components/ui/pricing/common';
import { getProPlansPerks } from '~/lib/stores/pricing/config';
import { freePricingSettingsStore } from '~/lib/stores/pricing/settings/freeSettings';
import { personalPricingList, type Pricing } from '~/utils/pricing';

const perks = getProPlansPerks({
  shouldDisplayExactTierTokens: false,
  pricing: personalPricingList[0],
});

export const FreePlanPricingSettingsSection = () => {
  const isLoading = useStore(freePricingSettingsStore.isLoading);

  const selectedPricing = useStore(freePricingSettingsStore.selectedPricing);
  const dropdownOptions = useStore(freePricingSettingsStore.dropdownOptions);

  const actions = useStore(freePricingSettingsStore.actions);
  const messages = useStore(freePricingSettingsStore.messages);

  useEffect(() => {
    freePricingSettingsStore.init();
  }, []);

  const onSelectPricing = (pricing: Pricing) => {
    freePricingSettingsStore.selectPricing(pricing);
  };

  return (
    <PricingSettingSectionWrapper className="flex flex-col lg:grid lg:grid-cols-[1fr_1px_1fr] gap-6">
      <div className="flex flex-col">
        <div className="flex flex-col gap-3">
          <span className="font-semibold text-xl">Upgrade to Pro</span>

          <PricingPrice label="per month" interval="monthly" pricing={selectedPricing} />
        </div>

        <div className="flex flex-col gap-1.5 mt-6">
          <PricingSelector
            options={dropdownOptions}
            label="Monthly tokens"
            selectedPricing={selectedPricing}
            onSelectPricing={onSelectPricing}
          />

          <PricingCardMessages messages={messages} />
        </div>

        <div className="flex flex-col gap-2 mt-4">
          {actions.map((action) => (
            <PricingCardActionButton key={action.id} action={action} loading={isLoading} disabled={false} />
          ))}
        </div>
      </div>

      <div className="w-px bg-bolt-ds-borderOutline hidden lg:block" />

      <PricingPerks label="You get:" items={perks} />
    </PricingSettingSectionWrapper>
  );
};
